// extracted by mini-css-extract-plugin
export default {"faiveForm":"faiveForm___Mgnjm","formGroup":"formGroup___eNfHR","input":"input___LQvXh","textarea":"textarea___jLvZJ","select":"select___g20LM","submitButton":"submitButton___BBhqz"};